import * as React from 'react';
import { useTranslation } from 'react-i18next';

export interface Contact {
    name: string
    emailAddress: string
    phoneNumber: string
    emailSubscriptions: number
}

export interface ContactEditorProps {
    contact: Contact | null
    onContactChange: (contact: Contact, isValid: boolean) => void
}

export function ContactEditorComponent({ contact, onContactChange }: ContactEditorProps) {
    const { t } = useTranslation();

    const [name, setName] = React.useState<string>(contact?.name ?? "")
    const [email, setEmail] = React.useState<string>(contact?.emailAddress ?? "")
    const [phoneNumber, setPhoneNumber] = React.useState<string>(contact?.phoneNumber ?? "")

    React.useEffect(() => {
        onContactChange({
            name: name,
            emailAddress: email,
            phoneNumber: phoneNumber,
            emailSubscriptions: 0
        }, true);
    }, [name, email, phoneNumber])

    return (
        <>
            <div className="form-floating mb-3">
                <input className="form-control" id="name" placeholder={t('name')} value={name} onChange={e => setName(e.target.value)} />
                <label htmlFor="name">{t('name')}</label>
            </div>
            <div className="form-floating mb-3">
                <input className="form-control" id="emailAddress" placeholder={t('email')} value={email} onChange={(e) => setEmail(e.target.value)} />
                <label htmlFor="emailAddress">{t('email')}</label>
            </div>

            <div className="form-floating mb-3">
                <input className="form-control" id="phoneNumber" placeholder={t('phoneNumber')} value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
                <label htmlFor="phoneNumber">{t('phoneNumber')}</label>
            </div>
        </>
    )
}